import { isAddress, encodeFunctionData } from 'viem';
import subscriptionModuleAbi from '@towns-protocol/generated/dev/abis/SubscriptionModuleFacet.abi';
/** Activate an existing subscription */
export async function activateSubscription(args) {
    const { entityId, smartAccount, signer, spaceDapp } = args;
    if (!spaceDapp) {
        throw new Error('spaceDapp is required');
    }
    if (!isAddress(smartAccount.address)) {
        throw new Error('Invalid smart account address');
    }
    const subscriptionModuleAddress = spaceDapp.config.addresses.subscriptionModule;
    if (!subscriptionModuleAddress) {
        throw new Error('Subscription module address not found');
    }
    // Encode the activateSubscription call
    const callData = getActivateSubscriptionData({ entityId });
    const response = await smartAccount.sendUserOp({
        toAddress: [subscriptionModuleAddress],
        callData: [callData],
        signer,
        functionHashForPaymasterProxy: 'activateSubscription',
        spaceId: undefined,
    });
    return response;
}
export function getActivateSubscriptionData(args) {
    const { entityId } = args;
    return encodeFunctionData({
        abi: subscriptionModuleAbi,
        functionName: 'activateSubscription',
        args: [entityId],
    });
}
/** Pause an existing subscription */
export async function pauseSubscription(args) {
    const { entityId, smartAccount, signer, spaceDapp } = args;
    if (!spaceDapp) {
        throw new Error('spaceDapp is required');
    }
    if (!isAddress(smartAccount.address)) {
        throw new Error('Invalid smart account address');
    }
    const subscriptionModuleAddress = spaceDapp.config.addresses.subscriptionModule;
    if (!subscriptionModuleAddress) {
        throw new Error('Subscription module address not found');
    }
    // Encode the pauseSubscription call
    const callData = encodeFunctionData({
        abi: subscriptionModuleAbi,
        functionName: 'pauseSubscription',
        args: [entityId],
    });
    const response = await smartAccount.sendUserOp({
        toAddress: [subscriptionModuleAddress],
        callData: [callData],
        signer,
        functionHashForPaymasterProxy: 'pauseSubscription',
        spaceId: undefined,
    });
    return response;
}
/**
 * Batches pause + activate into a single user operation.
 * Activating a sub syncs the subscription to the space's most recent configuration.
 */
export async function migrateSubscriptionCurrency(args) {
    const { entityId, smartAccount, signer, spaceDapp } = args;
    if (!spaceDapp) {
        throw new Error('spaceDapp is required');
    }
    if (!isAddress(smartAccount.address)) {
        throw new Error('Invalid smart account address');
    }
    const subscriptionModuleAddress = spaceDapp.config.addresses.subscriptionModule;
    if (!subscriptionModuleAddress) {
        throw new Error('Subscription module address not found');
    }
    const pauseCallData = encodeFunctionData({
        abi: subscriptionModuleAbi,
        functionName: 'pauseSubscription',
        args: [entityId],
    });
    const activateCallData = getActivateSubscriptionData({ entityId });
    const response = await smartAccount.sendUserOp({
        toAddress: [subscriptionModuleAddress, subscriptionModuleAddress],
        callData: [pauseCallData, activateCallData],
        signer,
        functionHashForPaymasterProxy: 'migrateSubscriptionCurrency',
        spaceId: undefined,
    });
    return response;
}
